export default {
  disclaimer: {
    summary:
      "Si prega di verificare che valuta e imposte siano corrette per la giurisdizione applicabile: è responsabilità dell'utente.",
    extra:
      "Queste informazioni sono fornite esclusivamente per comodità e non ci assumiamo alcuna responsabilità per l'accuratezza di valuta e/o imposte né per il loro pagamento nell'ambito dei nostri prodotti. Le informazioni su valuta e imposte hanno scopo puramente informativo.",
    show_more: 'Mostra di più',
    show_less: 'Mostra di meno',
  },
  partner_note:
    'Questi sono i valori predefiniti a livello di partner. I ristoranti del tuo account ereditano automaticamente questi valori, salvo override per singola categoria.',
  section_title: 'Aliquote fiscali per le voci di menu',
  new_category_placeholder: 'Nuova categoria',
  form: {
    name: {
      label: 'Categoria fiscale',
    },
    default_tax_rate: {
      label: 'Aliquota predefinita',
      tooltip: "Usata come fallback quando un'aliquota specifica per metodo d'ordine viene lasciata vuota.",
    },
    pickup_tax_rate: {
      label: 'Asporto',
    },
    delivery_tax_rate: {
      label: 'Consegna',
    },
    dine_in_tax_rate: {
      label: 'In ristorante',
    },
    on_site_tax_rate: {
      label: 'Ordini al tavolo',
    },
    show_zero_tax_in_summary: {
      label: 'Mostra imposta 0% nel riepilogo ordine',
    },
  },
  buttons: {
    add_category: 'Aggiungi nuova categoria fiscale',
    cancel: 'Annulla',
    save: 'Salva',
    confirm: 'Elimina',
    delete: 'Elimina categoria',
    reset: 'Ripristina ereditato',
  },
  delete_confirm: {
    title: 'Eliminare questa categoria fiscale?',
    description: 'Questa operazione non può essere annullata.',
  },
  scope_labels: {
    region: 'A livello regionale',
    partner: 'A livello di partner',
    restaurant: 'A livello di ristorante',
  },
  confirm_modal: {
    title: {
      fork: 'Renderla una categoria propria di questo ristorante?',
      owned: 'Applicare le nuove aliquote?',
      reset: 'Tornare alla categoria ereditata?',
    },
    affected_one: '{{count}} prodotto o categoria è attualmente collegato e verrà addebitato con le nuove aliquote.',
    affected_other:
      '{{count}} prodotti e categorie sono attualmente collegati e verranno addebitati con le nuove aliquote.',
    affected_settings_one:
      '{{count}} prodotto o categoria è attualmente collegato e utilizzerà le impostazioni aggiornate.',
    affected_settings_other:
      '{{count}} prodotti e categorie sono attualmente collegati e utilizzeranno le impostazioni aggiornate.',
    restaurants_one: 'Si tratta di {{count}} ristorante.',
    restaurants_other: 'Si tratta di {{count}} ristoranti.',
    acknowledge:
      'Capisco che confermando si modifica la categoria fiscale di tutti i prodotti attualmente collegati a questa categoria',
    impact_error: 'Impossibile verificare quali prodotti verrebbero modificati',
    cancel: 'Annulla',
    confirm: 'Conferma',
  },
  toasts: {
    load_error: 'Impossibile caricare le categorie fiscali.',
    failed_to_save_changes: 'Salvataggio delle modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
    delete_error: 'Impossibile eliminare questa categoria fiscale.',
    category_deleted: 'Categoria fiscale eliminata',
    category_reset: 'Categoria fiscale ripristinata a quella ereditata',
    reset_error: 'Impossibile ripristinare questa categoria fiscale.',
    impact_error: 'Impossibile verificare quali prodotti verrebbero modificati',
    impact_changed_one: 'Il numero di prodotti interessati è cambiato in {{count}}. Rivedi e conferma di nuovo.',
    impact_changed_other: 'Il numero di prodotti interessati è cambiato in {{count}}. Rivedi e conferma di nuovo.',
  },
};
